/**
 * Practice hub screen — lists published practice levels for players to play.
 */
import {
    listRuntimePracticeLevels,
    PRACTICE_CATEGORIES,
    type PracticeLevelMeta,
} from "./practice-levels";

export type PracticeScreenHooks = {
    onPlay: (levelIndex: number) => void;
};

let screenMounted = false;
let filterEl: HTMLSelectElement | null = null;
let gridEl: HTMLElement | null = null;
let emptyEl: HTMLElement | null = null;
let currentHooks: PracticeScreenHooks | null = null;

function buildCard(meta: PracticeLevelMeta): HTMLElement {
    const card = document.createElement("div");
    card.className = "practiceCard modeBox";

    const title = document.createElement("div");
    title.className = "practiceCardTitle";
    title.textContent = meta.displayName ?? `Practice ${meta.levelIndex}`;
    card.appendChild(title);

    if (meta.category) {
        const cat = document.createElement("span");
        cat.className = "practiceCardCategory";
        cat.textContent = meta.category;
        card.appendChild(cat);
    }

    if (meta.description) {
        const desc = document.createElement("div");
        desc.className = "practiceCardDesc";
        desc.textContent = meta.description;
        card.appendChild(desc);
    }

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "btn green practiceCardPlay";
    btn.textContent = "PLAY";
    btn.onclick = () => currentHooks?.onPlay(meta.levelIndex);
    card.appendChild(btn);

    return card;
}

export function refreshPracticeScreen(): void {
    if (!gridEl) return;
    const filter = filterEl?.value ?? "";
    const levels = listRuntimePracticeLevels();
    const filtered = filter ? levels.filter((l) => l.category === filter) : levels;

    gridEl.replaceChildren();

    if (!filtered.length) {
        emptyEl?.classList.remove("hidden");
        return;
    }
    emptyEl?.classList.add("hidden");

    for (const meta of filtered) {
        gridEl.appendChild(buildCard(meta));
    }
}

export function mountPracticeScreen(hooks: PracticeScreenHooks): void {
    currentHooks = hooks;

    if (!screenMounted) {
        screenMounted = true;
        filterEl = document.getElementById("practiceCategoryFilter") as HTMLSelectElement | null;
        gridEl = document.getElementById("practiceGrid");
        emptyEl = document.getElementById("practiceEmpty");

        if (filterEl) {
            while (filterEl.options.length > 1) filterEl.remove(1);
            for (const cat of PRACTICE_CATEGORIES) {
                const o = document.createElement("option");
                o.value = cat;
                o.textContent = cat;
                filterEl.appendChild(o);
            }
            filterEl.onchange = () => refreshPracticeScreen();
        }
    }

    refreshPracticeScreen();
}
